<template>
  <router-view :key="$route.fullPath"></router-view>
</template>


<script>
export default {
  data () {
    return {
      role: false,
    }
  },  
  mounted() {
  }
}
</script>
<style>
.loader {
  /* Loader Div Class */
  position: absolute;
  top: 0px;
  right: 0px;
  width: 100%;
  height: 100%;
  background-color: #eceaea;
  background-image: url(/img/custom/ajax-loader.gif);
  background-size: 50px;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 10000000;
  opacity: 0.4;
  filter: alpha(opacity=40);
}

/*
  Enter and leave animations can use different
  durations and timing functions.
*/
.slide-fade-enter-active {
  transition: all 0.3s ease-out;

      border: 1px #ff0000 solid;
    
    animation: blink 1s;
    animation-iteration-count: 3;

    
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from {
    
    border: 1px #ff0000 solid;
    
    animation: blink 1s;
    animation-iteration-count: 3;
}

.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.alerts-border {

}

@keyframes blink { 50% { border-color:#ff0000 ; }  }

</style>
